export async function transcribeAudio(audioBlob: Blob): Promise<string> {
  const form = new FormData()
  form.append('file', audioBlob, 'recording.webm')

  const resp = await fetch('/api/ai/transcribe', { method: 'POST', body: form })

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}))
    throw new Error(err.error || `Transcriptie mislukt (${resp.status})`)
  }

  const data = await resp.json()
  return data.text || ''
}
